import { flow } from 'lodash';
import {
  IPriceEstimationRecord,
  PricesAccordionTab,
  PricesSectionType,
  HistoryItem,
  PricesYearFilter,
  PricesBedsFilter,
} from 'store/state/selectors/insights/prices';
import { MarketplaceType, PoiId } from 'utils/entities';
import { normalizeRoomsRange } from 'components/filters/utils';


export const WIDGET_DESKTOP_TABLE_ROWS = 8;
export const WIDGET_MOBILE_TABLE_ROWS = 4;

export const getTabTotalItemsCount = (tab: PricesAccordionTab, currentBulletinId?: string) => {
  const data: Array<HistoryItem | IPriceEstimationRecord> = tab.tableData;
  let count = data.length;
  if (currentBulletinId && tab.tableData) {
    count = data.filter((item: IPriceEstimationRecord | HistoryItem) => item.id !== currentBulletinId).length;
  }
  return count;
};

export const getEnforcedSiValue = (price: number) => {
  if (price >= 1e6) return 1e6;

  return 1e3;
};

export const analyticsMap: Record<PricesSectionType, string> = {
  [PricesSectionType.LocalHistory]: 'history',
  [PricesSectionType.ComparableListings]: 'similar_listings',
  [PricesSectionType.Listing]: 'similar_listings',
};

const filterByYear = (year: PricesYearFilter, currentBulletinId: PoiId) => (items: HistoryItem[]) => year ? (
  items.filter(item => item.id === currentBulletinId || (item.date ? new Date(item.date).getFullYear() >= year[0] && new Date(item.date).getFullYear() <= year[1] : true))
) : items;

const filterByFinal = (onlyFinalTransactionsFilter: boolean, currentBulletinId: PoiId) => (items: HistoryItem[]) => (
  onlyFinalTransactionsFilter ? items.filter(item => item.id === currentBulletinId || item.isFinal) : items
);

const filterByBeds = (beds: PricesBedsFilter, currentBulletinId: PoiId, marketplace: MarketplaceType) => (items: HistoryItem[]) => {
  const [ from, to ] = normalizeRoomsRange(beds, marketplace);
  if (from === null && to === null) return items;
  if (from === to) return items.filter( item => item.id === currentBulletinId || item.beds === from || item.beds === to);
  if (from === null) return items.filter(item => Boolean(item.id === currentBulletinId || item.beds <= to));
  if (to === null) return items.filter(item => Boolean(item.id === currentBulletinId || item.beds >= from));
  return items.filter(item => Boolean(item.id === currentBulletinId || item.beds >= from && item.beds <= to));
};

interface ITableFilters {
  bedsFilter: PricesBedsFilter;
  showOnlyFinalTransactionsFilter: boolean;
  yearFilter: PricesYearFilter;
}

const historyFilter = ({ bedsFilter, showOnlyFinalTransactionsFilter, yearFilter } : ITableFilters, currentBulletinId: PoiId, marketplace: MarketplaceType) => flow([
  filterByBeds(bedsFilter, currentBulletinId, marketplace),
  filterByFinal(showOnlyFinalTransactionsFilter, currentBulletinId),
  filterByYear(yearFilter, currentBulletinId),
]);

export const filterFn = (filters : ITableFilters, data: any, currentBulletinId?: PoiId, marketplace?: MarketplaceType) => historyFilter(filters, currentBulletinId, marketplace)(data);
